import { ModelApiService } from './BaseApiService'

export default class ReleaseApiService extends ModelApiService {
  constructor() {
    super('ReleaseNotes')
  }

  async getReleaseById(id) {
    return await this.get(`${id}`)
  }

  async getReleases() {
    return await this.get(``)
  }

  async getRoadmap() {
    return await this.get(`getRoadmap`)
  }

  async getPreview(releaseId) {
    return await this.get(`getPreview/${releaseId}`)
  }

  async savePreview(payload) {
    return await this.post(`savePreview`, payload)
  }

  async sendTeamsMessage(releaseId) {
    return await this.get(`sendTeamsMessage/${releaseId}`)
  }

  async getAdaptiveCard(payload) {
    return await this.post(`getAdaptiveCard`, payload)
  }
}
